import { Validation } from "vendor/validatejs/validation.js";
import { handleUrlSearchParams } from "helpers/urlsearchparams/urlSearchParams";
import AjaxPost from "components/ajaxpost/ajaxpost";

export default () => {
  const _config = {
    inputsContainer: ".footer-input-container",
    form: "#newsletter-subscribe-footer",
    validationObject: null,
    constraints: {
      email: {
        presence: true,
        email: true,
      },
    },
  };

  const newsletterSubscribeFooterForm = document.querySelector(
    "#newsletter-subscribe-footer",
  );
  if (
    typeof newsletterSubscribeFooterForm === "undefined" ||
    newsletterSubscribeFooterForm === null
  ) {
    return;
  }

  // set validationObject
  _config.validationObject = new Validation({
    form: _config.form,
    constraints: _config.constraints,
    onValidationSubmit: (validationObject) => {
      _handleFormSubmit(validationObject);
    },
  });

  _config.validationObject.initValidation();

  /*-----------------------------FORM SUBMIT | submit the form------------------------------*/
  const _handleFormSubmit = (validationObject) => {
    const formElement = validationObject.config.formElement;

    const params = new handleUrlSearchParams({
      form: formElement,
      fieldSelector: '[data-footerurlsearchparams="1"]',
      addEmptyFields: false,
    });
    const postData = params.renderSearchParams();

    const postForm = new AjaxPost({
      formElement,
      validationObject,
      postData,
      hideFormOnSuccess: true,
      messageContainer: document.getElementById(
        "footer-newsletter-message-container",
      ),
    });

    postForm.postFormData();
  };
};
